module.exports = __webpack_public_path__ + "img/Asian Quinoa Bowl-Ginger Shrimp.8ccc4f12.jpg";